<template>
    <v-dialog
        v-model="dialog" 
        persistent
        max-width="550px"
        transition="dialog-transition">
        <template v-slot:activator="{ on }">
            <v-btn color="#0B3F67" class="white--text" v-on="on">Agregar Acción<v-icon right>mdi-plus-box-outline</v-icon></v-btn>
        </template>
        <v-card :loading="loading">
            <v-card-title class="pa-0">
              <ModalTitle titulo="Agregar Acción de Reducción" @cancelar="cancelar"/>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row class="pt-3">
                    <v-col cols="12" md="12" class="pt-0 pb-0">
                        <v-select
                            :items="actividades"
                            v-model="accion.tipo"
                            :error-messages="tipoErrors"             
                            @change="$v.accion.tipo.$touch()"
                            @blur="$v.accion.tipo.$touch()"
                            counter="200"
                            required                            
                            label="Tipo de Actividad" 
                        ></v-select>
                    </v-col>
                    <v-col v-if="isOtro" cols="12" md="12" class="pt-0 pb-0">
                        <v-textarea
                            rows="3"
                            label="Nombre Actividad"
                            counter="100"
                            v-model="otro"
                            :error-messages="otroErrors"             
                            @change="$v.otro.$touch()"
                            @blur="$v.otro.$touch()"
                            required
                        >
                        </v-textarea>
                    </v-col>
                    <v-col cols="12" md="12" class="pt-0 pb-0">
                        <v-textarea
                            rows="3"
                            label="Descripción"
                            counter="500"
                            v-model="accion.descripcion"
                            :error-messages="descErrors"             
                            @change="$v.accion.descripcion.$touch()"
                            @blur="$v.accion.descripcion.$touch()"
                            required
                        ></v-textarea>
                    </v-col>
                    <v-col cols="12" md="6" class="pt-0 pb-0">
                        <v-text-field
                            label="Cantidad Actividades"
                            v-model="accion.cantidad"
                            v-mask="mask"
                            hint="Ingresar solo números"
                            :error-messages="cantErrors"             
                            @change="$v.accion.cantidad.$touch()"
                            @blur="$v.accion.cantidad.$touch()"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6" class="pt-0 pb-0">
                        <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="fechaMoment"
                                    label="Fecha de la Actividad"
                                    prepend-inner-icon="mdi-calendar-month"
                                    readonly
                                    v-on="on"
                                    :error-messages="fechaErrors"
                                    @change="$v.accion.fecha.$touch()"
                                    @blur="$v.accion.fecha.$touch()"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="accion.fecha" locale="es-CR" @input="menu = false" :min="fechaMinima" :max="fechaMaxima"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <div class="d-flex justify-space-stretch">
                    <div class="file-width pr-2 overflow-x-hidden ">
                        <v-file-input 
                            v-if="!fromRepository"
                            accept=".png, .jpeg, .jpg" 
                            show-size counter 
                            multiple 
                            v-model="archivos"
                            :error-messages="docErrors"
                            @input="$v.archivos.$touch()"
                            @blur="$v.archivos.$touch()" 
                            label="Agregar Evidencias">
                        </v-file-input>
                        <RepoNameDocs v-else :docs="selectEvi" />
                    </div>
                    <div class="d-flex align-center">
                        <CargarDesdeRepositorio 
                            titulo="Repositorio" 
                            origen="accionReduccion" 
                            :anioConsulta="anioConsulta" 
                            :singleSelect="false"
                            v-model="selectEvi"
                            :notSelectable="null"
                            :tipo="2"
                        />
                    </div>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" :disabled="loading" text @click.native="cancelar">Cancelar</v-btn>
                <v-btn color="#0B3F67" :loading="loading" text @click="agregarAccion">Agregar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import moment from "moment"
import axios from "@/axios.js"
import { mask } from "vue-the-mask"
import { sanityInputText } from "@/utils"
import ModalTitle from '@/components/utils/ModalTitleComponent'
import RepoNameDocs from "@/components/documentos/RepoNameDocs.vue"
import { required, maxLength, requiredIf } from "vuelidate/lib/validators"
import CargarDesdeRepositorio from "@/components/documentos/CargarDesdeRepositorio.vue"

//Custom validations
const maxFileSize = (files) => {
    if(files != null) {
        let maximo = files.length * (5 * 1024 * 1024);
        let total = 0;
        files.forEach(file => {
            total += file.size
        });        
        return total <= maximo;
    }
    return true;
}

export default {
    created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    }, 
    components: {
      ModalTitle,
      RepoNameDocs,
      CargarDesdeRepositorio
    },
    props: [
        'cantAcciones'
    ],
    mounted() {
            let indicadorActual = parseInt(this.$store.getters.indicadorActual);
            let constantes = this.$store.getters.constantes;
            switch(indicadorActual) {
                case constantes.indicadorCombustibles:
                    this.actividades = this.actividadesFosil.sort();
                    break;
                case constantes.indicadorAguasResiduales:
                    this.actividades = this.actividadesAguaRes.sort();
                    break;
                case constantes.indicadorAgua:
                    this.actividades = this.actividadesAgua.sort();
                    break;
                case constantes.indicadorEnergia:
                    this.actividades = this.actividadesEnergia.sort();
                    break;
                case constantes.indicadorContamiAdmosf://karol debe definir esta lista
                    this.actividades = this.actividadesContam.sort();
                    break;
                case constantes.indicadorResiduos:
                    this.actividades = this.actividadesResiduos.sort();
            }
            this.actividades.push("Otro")
     }, 
    directives: {
        mask,
    },
    computed: {
        fileSize() {
            return this.archivos != null ? this.archivos.length : 0;
        },
        anioConsulta() {
            return this. $store.getters.anioConsulta;
        },
        fechaMaxima() {
            return `${this.anioConsulta}-12-31`;
        },
        fechaMinima() {
            return `${this.anioConsulta}-01-01`;
        },
        fechaMoment () {
            return this.accion.fecha ? moment(this.accion.fecha).format('DD/MM/YYYY') : '';
        },
        tipoErrors () {
            const errors = []
            if (!this.$v.accion.tipo.$dirty) return errors
            !this.$v.accion.tipo.required && errors.push('Campo requerido')
            !this.$v.accion.tipo.maxLength && errors.push('No debe exceder el tamaño permitido.')
            return errors
        },
        descErrors () {
            const errors = []
            if (!this.$v.accion.descripcion.$dirty) return errors
            !this.$v.accion.descripcion.required && errors.push('Campo requerido')
            !this.$v.accion.descripcion.maxLength && errors.push('No debe exceder el tamaño permitido.')
            return errors
        },
        cantErrors () {
            const errors = []
            if (!this.$v.accion.cantidad.$dirty) return errors
            !this.$v.accion.cantidad.required && errors.push('Campo requerido')
            return errors
        },
        docErrors () {
            const errors = []
            if (!this.$v.archivos.$dirty) return errors            
            !this.$v.archivos.required && errors.push('La evidencia es requerida.')
            !this.$v.archivos.maxFileSize && errors.push('El tamaño total debe ser menor a ' + this.fileSize + 'MB.')        
            return errors
        },
        otroErrors(){
            const errors = []
            if(this.accion.tipo === "Otro" && !this.$v.otro.$dirty) return errors
            !this.$v.otro.required && errors.push('Dato requerido')
            return errors
        }, 
        fechaErrors () {
            const errors = []
            if (!this.$v.accion.fecha.$dirty) return errors
            !this.$v.accion.fecha.required && errors.push('Campo requerido')
            return errors
        },
        indicadorActual() {
            return this.$store.getters.indicadorActual;
        },
        usuario(){
            return this.$store.getters.usuario;
        },
        instalacion() {
            return this. $store.getters.sucursal;
        },
        isOtro(){
            return this.accion.tipo === "Otro" ? true : false;
        },
        fromRepository() {
            return this.selectEvi.length > 0
        }
    },
    data: () => ({
        tipoAccion: '',
        dialog: false,
        loading: false,
        menu: false,
        mask: '####',
        selectEvi: [],
        accion: {
            tipo: '',
            descripcion: '',
            cantidad: '',
            fecha: null,
        },
        archivos:[],
        actividades:[],
        actividadesFosil:[
            "Adquisición de equipo más eficiente.",
            "Mantenimiento preventivo de la flotilla vehicular, maquinaria y/o equipo.",
            "Implementación de dispositivos (mecánicos) para aumentar la eficiencia.",
            "Definición de rutas más adecuadas para reducir consumos.",
            "Implementar iniciativas de movilidad sostenible.",
            "Acondicionar estacionamientos para bicicletas.",
            "Pizarras informativas.",
            "Compartir información asociada al parámetro por distintos medios: redes sociales, correo electrónico, chats, otros.",
            "Colocación de calcomanías.",
            "Incluir los vehículos de colaboradores y proveedores.",
            "Implementar iniciativas para mejorar el registro y control de los consumos.",
            "Sistemas para el control del consumo",
            "Campañas de comunicación",
            "Promover transporte compartido",
            "Promover iniciativas de movilidad sostenible",
            "Planificar las giras o gestiones de trabajo",
            "Definir rutas y el vehiculo mas adecuado",
            "Realizar varios trámites en un mismo viaje",
            "Medicion de consumo de combustibles en colaboradores / proveedores",
            "Reduccion de consumo por concepto de kilometraje",
            "Reduccion de consumo por concepto de viajes aereos"
            ],
        actividadesAguaRes:[
            "Sustituir productos de limpieza a biodegradables",
            "Utilizar trampas de grasa",
            "Reutilización de aguas tratadas",
            "Implementar el uso de biojardineras",
            "No vertido de residuos en fregaderos y desagues",
            "Pizarras informativas",
            "Compartir información por medios sociales",
            "Colocación de calcomanías",
            "Procedimiento interno de limpieza"
            ],
        actividadesAgua:[
            "Mejoras y mantenimiento preventivo del sistema de abastecimiento de agua",
            "Cambios de equipos y accesorios de ahorro de agua",
            "Cosecha de agua de lluvia",
            "Reutilización de agua",
            "Establecer horarios de uso adecuado de agua",
            "Ajustar la presión del agua",
            "Verificar la calibración del medidor",
            "Pizarras informativas",
            "Compartir información por medios sociales",
            "Mejorar el registro y control de consumos",
            "Estaciones de Lavado de Manos"
            ],
        actividadesEnergia:[
            "Uso de fuentes de energía renovables no convencionales",
            "Cambio a tecnologías de mayor eficiencia energética",
            "Aprovechamiento de luz natural",
            "Uso de colores claros en paredes, techo y mobiliario",
            "Utilizar los aires acondicionados a 24C",
            "Configurar el equipo de cómputo en el modo de ahorro de energía",
            "Techos y paredes verdes para la climatización de ambientes internos",
            "Desconectar equipos electronicos y electricos cuando no estan en uso",
            "Calibrar los medidores eléctricos",
            "técnicas para el aislamiento térmico de las instalaciones",
            "Sistemas de monitoreo y control de consumo de electricidad",
            "Pizarras informativas",
            "Compartir información por medios sociales",
            "Mejorar el registro y control de consumos"
            ],
        actividadesResiduos:[
            "Innovación en pro de la reutilización de los residuos",
            "Sustitución de materiales o insumos por otros con mayor capacidad de biodegradación",
            "Aplicación de técnicas o tecnologías limpias para el tratamiento y aprovechamiento de los residuos",
            "Aplicación de técnicas o tecnologias para reducir el impacto de residuos peligrosos",
            "Pizarras Informativas",
            "Compartir información por medios sociales",
            "Mejorar el registro y control de consumos",
            "Colocación de calcomanías"
            ],
        actividadesContam:[
            "Adquisición de equipos que utilicen gases refigerantes de menor impacto en el ambiente",
            "Mantenimiento preventivo realizado por personal capacitado ",
            "Implementación de dispositivos (mecánicos) para aumentar la eficiencia",
            "Pizarras informativas",
            "Compartir información asociada al parámetro por distintos medios: redes sociales, correo electrónico, chats, otros",
            "Colocación de calcomanías",
            "Implementar iniciativas para mejorar el registro y control de los consumos",
        ],
        otro : "",
    }),
    validations: {
        accion: {
            tipo: {
                maxLength: maxLength(200),
                required
            },
            descripcion: {
                maxLength: maxLength(500),
                required
            },
            cantidad: {
                required
            },
            fecha: {
                required
            },
        },
        archivos: {
            required: requiredIf(function(){
                return !this.fromRepository;
            }),
            maxFileSize
        },
        otro: {
            required: requiredIf(function(){
                return this.accion.tipo === "Otro" ? true : false;
            })
        }
    },
    methods: {
        agregarAccion() {
            this.$v.$touch();
            if(!this.$v.$invalid) {
                this.loading = true;
                this.sanityData()
                let formData = new FormData();
                this.archivos.forEach(file => {
                    formData.append('archivos', file);
                });
                formData.append("otro", this.otro);    
                formData.append('tipoActividad', this.accion.tipo);
                formData.append('descripcion', this.accion.descripcion);
                formData.append('cantidadActividades', this.accion.cantidad); 
                formData.append('fechaActividad', this.accion.fecha);
                formData.append('idInstalacion', this.instalacion.id);
                formData.append('indicador', this.indicadorActual);
                formData.append('idUsuario', this.usuario.id);
                if(this.fromRepository){
                    this.selectEvi.forEach(doc => {
                        formData.append('idsRepositorio', JSON.stringify(doc.repositorioId));
                    });
                }
                axios.post("/accionReduccion/agregar", formData)
                .then(response => {
                    this.$store.dispatch('noti',{mensaje: 'Acción de reducción agregada', color:'success'});   
                    this.$emit('reload');
                    this.cancelar();
                }).catch(error => {
                  if (error.request && error.request.status === 401) {
                    this.$store.commit('showSessionDialog', true);
                  } else {
                    if (error.request && error.request.status === 415) {
                      this.$store.dispatch('noti', {mensaje: error.response.data, color: 'error'});
                      this.loading = false;
                    } else {
                      this.$store.dispatch('noti', {mensaje: 'Ocurrió un error no se agregó la acción de reducción', color:'error'});  
                      this.cancelar();   
                    }
                  }         
                })
            }
        },
        cancelar() {
            this.accion = {
                tipo: '',
                descripcion: '',
                cantidad: '',
                fecha: null,
            };
            this.archivos=[];
            this.otro = "";
            this.$v.accion.$reset();    
            this.$v.archivos.$reset();
            this.$v.otro.$reset();   
            this.dialog = false;
            this.loading = false;
            this.selectEvi = []
        },
        sanityData() {
            this.otro = sanityInputText(this.otro)
            this.accion.tipo = sanityInputText(this.accion.tipo)
            this.accion.descripcion = sanityInputText(this.accion.descripcion)
        },
    },
}
</script>
<style scoped>
    .file-width {
        width: 100%;
    }
</style>